import { makeStyles } from '@surveycake/rc';
import { itemStyle } from '../styles';

export const useStyles = makeStyles([
  [
    'unselectedItem',
	theme => `
		:lang(ar) {
			transform: scaleX(-1);
			direction: rtl;
		}
		${itemStyle(theme)}
		border-color: ${theme.color.text.B};
		color: ${theme.color.text.B4};
	`
  ],
  [
    'unselectedItemDisabled',
	theme => `
		:lang(ar) {
			transform: scaleX(-1);
			direction: rtl;
		}
		${itemStyle(theme)}
		border-color: ${theme.color.text.HB};
		color: ${theme.color.text.B2};
		cursor: not-allowed;
	`
  ]
]);
